module.exports = __webpack_public_path__ + "img/NotifySuccess.24b1b527.svg";